import React from 'react';
import { SnackbarProps as MaterialSnackbarProps } from '@mui/material';
import { Subject } from 'rxjs';

export type SnackbarProps = Omit<MaterialSnackbarProps, 'action' | 'message'>;

export interface SnackbarState {
  action?: React.ReactNode;
  message?: React.ReactNode;
  SnackbarProps?: SnackbarProps;
}

const snackbarSubject = new Subject<SnackbarState>();

class SnackbarStore {
  public static getObservable() {
    return snackbarSubject.asObservable();
  }

  public static hide() {
    return snackbarSubject.next();
  }

  public static show(
    message: React.ReactNode,
    action?: React.ReactNode,
    SnackbarProps?: SnackbarProps
  ) {
    return snackbarSubject.next({ action, message, SnackbarProps });
  }
}

// Export a singleton instance
export default SnackbarStore;
